import styled from "@emotion/styled";
import {Link} from "../../elements/link";

export const LinkIconWrapper = styled(Link)(() => ({
  height: 40,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 0px 16px 0px #1D314014",
  width: 40,
  background: "#FFFFFF",
  borderRadius: 100,
  cursor: "pointer",
  alignSelf: "center",
  transition: "box-shadow 0.5s ease",
  ":hover": {
    boxShadow: "0px 0px 24px 0px rgba(29, 49, 64, 0.16)",
  },
}));

export const Icon = styled.img(() => ({
  width: 20,
  height: 20,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
}));
